import TextareaAutosize from "react-textarea-autosize";
import { BrandificationImageFallback } from "../../components";
import FavoriteChildBrandIcon from "../../components/svgs/FavoriteChildBrandIcon";
import FavoriteNowBrandIcon from "../../components/svgs/FavoriteNowBrandIcon";
import { getFallbackImageFromUrl, getImageDownloadUrl, getImageFromUrl } from "../../utils/imageService";
import StatusPointsInfo from "../Profile/StatusPointsInfo";

const ProfileHeader = props => {
  const { t, user, client, profile } = props;
  const { favoriteBrand, favoriteChildBrand, favoriteBrandImage, favoriteChildBrandImage } = user;
  const statisticProfile = { ...profile, ...user, role: "user" };

  const Brand = ({ title, brand, brandImage, icon }) => (
    <div className="brand-container">
      {brand && <div className="brand-title">{title}</div>}
      {brandImage && (
        <div className="brand-image">
          <img src={getImageDownloadUrl(brandImage)} className="image-container" alt="" />
        </div>
      )}
      {brand && (
        <div className="brand-info">
          <div className="brand-text">{brand}</div>
          {icon}
        </div>
      )}
    </div>
  );

  return (
    <div className="   ">
      <div className="avatar">
        <BrandificationImageFallback
          src={getImageFromUrl(user.photoURL)}
          fallbackImage={getFallbackImageFromUrl(user.photoURL)}
          className={user.photoURL ? "logo" : "no-image"}
        />
      </div>
      <div className="user-name">{user.name}</div>
      <div className="user-role">{user.userRole}</div>
      <div className="d-flex justify-content-center">
        <StatusPointsInfo onlyBadges customProfile={statisticProfile} />
      </div>
      {user.roleDescription && (
        <div className="user-desc">
          <TextareaAutosize className="brand-description-area" value={user.roleDescription} disabled />
        </div>
      )}
      <div className="brands-container brand-row">
        {favoriteChildBrand && (
          <Brand
            title={t("profile.FavoriteChildBrandLabel")}
            brand={favoriteChildBrand}
            brandImage={favoriteChildBrandImage}
            icon={<FavoriteChildBrandIcon color={client?.altColor} />}
          />
        )}
        {favoriteBrand && (
          <Brand
            title={t("profile.FavoriteBrandLabel")}
            brand={favoriteBrand}
            brandImage={favoriteBrandImage}
            icon={<FavoriteNowBrandIcon color={client?.altColor} />}
          />
        )}
      </div>
    </div>
  );
};

export default ProfileHeader;
